/**
 * Échéancier d'un contrat mensualisé : la dernière mensualité absorbe l'écart d'arrondi, pour que la somme des
 * mensualités soit EXACTEMENT le total du devis (1 447,50 € sur 12 mois = 11 × 120,63 € + 120,57 €, et non
 * 12 × 120,63 € = 1 447,56 €). Demande d'Emeni, 2026-10-14 : « ça doit être exact ».
 *
 * Si la mensualité saisie n'est pas celle qui découle du total (l'établissement a fixé son propre montant),
 * le total du contrat est simplement mensualité × durée, sans ajustement.
 *
 * Miroir exact de `echeancierContrat` dans functions/api/[[path]].js.
 */
export interface Echeancier {
    total: number;
    mensualite: number;
    derniere: number;
    nbMois: number;
    ajustee: boolean;
}

const arrondi = (n: number) => Math.round(n * 100) / 100;

export function echeancier(totalDevis: number | null | undefined, mois: number, mensualite: number): Echeancier {
    const nbMois = Math.max(1, Math.round(Number(mois) || 1));
    const m = arrondi(Number(mensualite) || 0);
    const t = Number(totalDevis) || 0;
    const decoule = t > 0 && Math.abs(arrondi(t / nbMois) - m) < 0.005;
    const total = decoule ? arrondi(t) : arrondi(m * nbMois);
    const derniere = arrondi(total - m * (nbMois - 1));
    return { total, mensualite: m, derniere, nbMois, ajustee: nbMois > 1 && Math.abs(derniere - m) >= 0.005 };
}
